import React, { useMemo, useState } from 'react'

import { useGroups } from 'redux/hooks/Groups'
import { useGroupActions } from 'redux/actions/Groups'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'language/translator'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import { CreateGroupBody } from 'types/GlobalGroup'

import Button from 'components_new/atoms/Button'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import GroupSettingsForm from 'components_new/organisms/GroupSettingsForm'

import { getDefaultCreateGroupBody } from 'components_new/organisms/GroupSettingsForm/types'

interface AddGroupDialogProps {
  onClose: () => void
  open: boolean
}

const AddGroupDialog = (props: AddGroupDialogProps) => {
  const { onClose, open } = props

  const { t } = useTranslation()

  const { account } = useAccountSettings()

  const [data, setData] = useState<CreateGroupBody>(
    getDefaultCreateGroupBody(account)
  )

  const { allGroups } = useGroups()
  const groupNames = useMemo(() => {
    return allGroups.map((group) => group.name)
  }, [allGroups])

  const emptyName = !data.name
  const invalidName = groupNames.includes(data.name)

  const history = useHistory()
  const { tryCreateGroup } = useGroupActions()
  const handleSubmit = () => {
    tryCreateGroup(data, (err, id) => {
      if (!err) {
        onClose()
        history.push(`/groups/${id}`)
      }
    })
  }

  const handleChange = (data: CreateGroupBody) => {
    setData(data)
  }

  return (
    <SimpleDialog
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            {t('global', 'cancel')}
          </Button>
          <Button
            disabled={emptyName || invalidName || data.owners.length === 0}
            variant="contained"
            onClick={handleSubmit}
          >
            {t('global', 'create')}
          </Button>
        </>
      }
      onClose={onClose}
      open={open}
      title={t('groups', 'create_group')}
    >
      <GroupSettingsForm onChange={handleChange} />
    </SimpleDialog>
  )
}

export default AddGroupDialog
